import React from "react";
import { Bar } from "react-chartjs-2";
import { dataForDayTemplate, dataForLucketTemplate } from "../chartTemplates";
import { STATUS_OPTION_HEX_PALLETE } from "../../../components/buckets/constants";

export function DayPoints({filteredBuckets,filteredBucketsWeek}){
    let parentLucketsWeek = filteredBucketsWeek.filter(l=>!l.parentRowID)
    let labels = parentLucketsWeek.map(l=>l.name)
    let zeros = labels.reduce((acc,label)=>{
       acc[label] = 0
       return acc
    },{})
    const options1 =  {
        scales: {
            y: {
            beginAtZero: true
            }
        }
    }
    let parentLucketsASPoints = filteredBuckets.reduce((acc,v,i,ar)=>{
        let parentLucket 
        if(v.parentRowID){
            parentLucket = filteredBuckets.filter(l => l.rowID == v.parentRowID)[0]
            if(!parentLucket) return acc
            acc[parentLucket.name] = acc[parentLucket.name]+ Number(v.points)
        }
        else{
            acc[v.name] = Number(v.points)
        }
       

        return acc
    },zeros)
    let parentLuckets = filteredBuckets.filter(l=>!l.parentRowID)
   
 
    let backgroundColors = parentLuckets.map(l=>STATUS_OPTION_HEX_PALLETE[l.actionStatus])
 

    return <Bar
              type="bar"
              options={options1}
              data={dataForLucketTemplate(parentLucketsASPoints, backgroundColors, labels,"Day Action Points By Lucket")}
              />
}